import React from 'react'

import { StyledTableCell, StyledTableRow } from '../../../assets/theme/theme'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import styles from './ClientViewTable.module.scss'
import DoDisturbOutlinedIcon from '@mui/icons-material/DoDisturbOutlined'
import { Grid, Table, TableHead, TextField, Tooltip, TableBody, TableContainer, CircularProgress, InputAdornment } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { ClientDto } from '../../../utilities/models'
import { APP_FEATURE_KEYS } from '../../../utilities/constants'
import { AppAuthorizer } from '../../shared'
const ClientViewTable: React.FC<{
  activeUserRole: any;
  clientList: Array<ClientDto>;
  page: number;
  rowsPerPage: number;
  isEditingRow: any;
  isEditDialogOpen: boolean;
  clientListIsLoading: boolean;
  searchText: string;
  searchClients(event: any): void;
  onRowEditTrigger(arg: any): void;
  onRowStatusChangeTrigger(arg: any): void;
  clientEditClick(): void;
}> = (props) => {
  return (
    <Grid container spacing={3}>
      <Grid item md={3} className="sectionTitleHolder">
        <h3>Manage Client</h3>
        <p>Click the edit icon under Action to edit an existing client. <br /> <br />
          Click on the enable/disable icons to Activate/Deactivate client.</p> <br />
        <TextField
          value={props.searchText}
          // label="Search By Client name"
          placeholder="Search Client / SBU"
          variant="outlined"
          color='primary'
          size="small"
          fullWidth
          onChange={props.searchClients}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon fontSize='small' />
              </InputAdornment>
            )
          }}
        />
      </Grid>
      <Grid item md={9}>
        <TableContainer>
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left" >Name</StyledTableCell>
                <StyledTableCell align="left" >SBU</StyledTableCell>
                <StyledTableCell align="left" >Description</StyledTableCell>
                <StyledTableCell align="left" >Status</StyledTableCell>
                <StyledTableCell align="left" width={70}>Action</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {(!props.clientListIsLoading && props.clientList.length > 0) && (props.rowsPerPage > 0
                ? props.clientList.slice(
                  props.page * props.rowsPerPage,
                  props.page * props.rowsPerPage + props.rowsPerPage
                )
                : props.clientList
              ).map((row: ClientDto, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell align="left" >{row.clientName}</StyledTableCell>
                  <StyledTableCell align="left" >{row.sbuName}</StyledTableCell>
                  <StyledTableCell align="left" >{row.clientDesc}</StyledTableCell>
                  <StyledTableCell align="left" >
                    {row.isEnabled === true &&
                      <span className={styles.enabled}>Enabled</span>}
                    {row.isEnabled === false &&
                      <span className={styles.disabled}>Disabled</span>}
                  </StyledTableCell>
                  <StyledTableCell align="left" width={70} >
                    <div className="layout-row">
                      <AppAuthorizer
                        activeRoleFeatures={props.activeUserRole.data.features}
                        authorizedFeatureKey={[APP_FEATURE_KEYS.UPDATE_CLIENT]}
                      >
                        <Tooltip title="Edit Client">
                          <EditOutlinedIcon
                            onClick={() => props.onRowEditTrigger(row)}
                            className="editIconStyle" fontSize="small"></EditOutlinedIcon>
                        </Tooltip>
                        {row.isEnabled === false &&
                          <Tooltip title="Enable Client">
                            <CheckCircleOutlineIcon
                              onClick={() => props.onRowStatusChangeTrigger(row)}
                              fontSize="small" style={{ color: '#4CAF50' }}></CheckCircleOutlineIcon>
                          </Tooltip>}
                        {row.isEnabled === true &&
                          <Tooltip title="Disable Client">
                            <DoDisturbOutlinedIcon
                              onClick={() => props.onRowStatusChangeTrigger(row)}
                              fontSize="small" style={{ color: '#e90c10' }}></DoDisturbOutlinedIcon>
                          </Tooltip>}
                      </AppAuthorizer>
                    </div>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
              {props.clientListIsLoading &&
                <StyledTableRow>
                  <StyledTableCell colSpan={7} align="center">
                    <CircularProgress className={styles.spinnerAlign} color="primary" size={20} /> Loading...
                  </StyledTableCell>
                </StyledTableRow>
              }
              {(!props.clientListIsLoading && props.clientList.length === 0) &&
                <StyledTableRow>
                  <StyledTableCell colSpan={5} align="center">
                    No Records Available.
                  </StyledTableCell>
                </StyledTableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>
        {props.children}
      </Grid>
    </Grid>
  )
}

export default ClientViewTable
